module.exports = "<h2 id=\"datahunter-react-component\">datahunter react Component</h2>\n<h3 id=\"-\">安装</h3>\n<pre><code class=\"lang-bash\">    npm install dh-component\n</code></pre>\n<h3 id=\"-\">使用</h3>\n<pre><code class=\"lang-jsx\">import { Test } from &#39;dh-component&#39;;\nReactDOM.render(&lt;Test /&gt;, mountNode);\n</code></pre>\n<h3 id=\"-\">导入依赖样式</h3>\n<pre><code class=\"lang-jsx\">import &#39;dh-component/dist/index.css&#39;;\n</code></pre>\n";


//////////////////
// WEBPACK FOOTER
// ./example/home/home.md
// module id = 222
// module chunks = 0